var _path, _ellipse, _path2, _path3, _path4, _path5, _rect, _path6, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 135,
    viewBox: "0 0 252 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 110H218.5",
    stroke: "#D6D8E7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.5,
    cy: 131.5,
    rx: 44.5,
    ry: 3.5,
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62V109",
    stroke: "#D6D8E7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 73C28 73 34 67.5 34 65.5C34 67.5 40 73 45 73M23 84C28 84 34 78.5 34 76.5C34 78.5 40 84 45 84M23 95.5C28 95.5 34 90 34 88C34 90 40 95.5 45 95.5",
    stroke: "#D6D8E7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 73H210C210 69 214 60.5 222 60.5C227 60.5 233 63.5 233 73C233 70.5 234.5 67.5 238 67.5C240.5 67.5 243 69 243 73C245.4 73 248.667 73 250 73M3 15C3.4 15 12.5 15 17 15C17 12 18.5 9 22.5 9C24.5 9 28 10 28 15C28 12 29 2 40 2C44 2 51 4.5 51 15C51 11.5 53.5 9 57 9C60 9 62 10.5 62 15C65.6 15 68.8333 15 70 15",
    stroke: "#D6D8E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20H96M91 15V25M151 8L160 17M151 17L160 8",
    stroke: "#D6D8E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 34,
    width: 66,
    height: 96,
    rx: 10,
    fill: "white",
    stroke: "#74CCF4",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 54H136M103 70H136M103 85.5H136",
    stroke: "#74CCF4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 12,
    r: 4,
    fill: "#D6D8E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 39,
    r: 4,
    fill: "#D6D8E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.e1a3a2ff60ed4b4365081adfa3372bc5.svg";
export { ForwardRef as ReactComponent };